module.exports = __webpack_public_path__ + "img/max-file-add--excel.51321fac.svg";